class DraftOrderForm extends HTMLElement {
  constructor() {
    super()
    this.salesRepresentative = this.querySelector('input[name="salesRepresentative"]').value
    this.customersSelector = this.querySelector('select[name="customer"]')
    this.draftOrderButton = this.querySelector('button[name="draftOrderCreate"]')
    this.draftOrderText = this.draftOrderButton.querySelector('.submit-text')
    this.draftOrderSpinner = this.draftOrderButton.querySelector('.loading-overlay')
    this.generalError = this.querySelector('#GeneralError')
    this.successMessage = this.querySelector('#Success')
    this.regularSubmitButton = this.querySelector('button[type="submit"]')
  }

  connectedCallback() {
    this.loadCustomers()
    this.customersSelector.addEventListener('change', this.handleCustomerSelectorChange.bind(this))
    this.draftOrderButton.addEventListener('click', this.handleSubmit.bind(this))
  }

  async handleSubmit(e) {
    try {
      const parseId = id => id.split(':').shift()
      e.preventDefault()
      this.draftOrderText.classList.add('hidden')
      this.draftOrderSpinner.classList.remove('hidden')

      const cartData = await fetch(window.routes.cart_url, fetchConfig())
      const cart = await cartData.json()
      const items = cart.items.map(item => { return { variantId: parseId(item.key), quantity: parseInt(item.quantity) } })
      const body = {
        salesRepresentativeId: `gid://shopify/Customer/${this.salesRepresentative}`,
        customerId: this.customersSelector.value,
        items
      }

      const response = await fetch(window.routes.b2b_draft_order_url, {
        ...fetchConfig(),
        ...{
          body: JSON.stringify(body)
        }
      })
      const responseData = await response.text()

      if (responseData.success === false) {
        this.generalError.classList.remove('hidden')
        this.successMessage.classList.add('hidden')
      } else {
        this.successMessage.classList.remove('hidden')
        this.generalError.classList.add('hidden')
      }

      localStorage.removeItem('selectedCustomer')
      await fetch('/cart/clear.js', fetchConfig())
      window.location.href = '/account'
    } catch (e) {
      console.error(e)
      this.successMessage.classList.add('hidden')
      this.generalError.classList.remove('hidden')
    }
    this.draftOrderText.classList.remove('hidden')
    this.draftOrderSpinner.classList.add('hidden')
  }

  async loadCustomers() {
    const salesRepresentative = `gid://shopify/Customer/${this.salesRepresentative}`
    this.querySelector('label[for="customer"] span').classList.remove('hidden')
    const response = await fetch(window.routes.b2b_customers_url, { ...fetchConfig(), ...{ body: JSON.stringify({salesRepresentative}) } })

    const responseData = await response.json()

    this.customersSelector.innerHTML = `<option value=""></option>`
    const selectedCustomer = localStorage.getItem('selectedCustomer')

    if (responseData.length < 1) {
      this.querySelector('label[for="customer"]').classList.add('hidden')
      this.customersSelector.classList.add('hidden')
      this.regularSubmitButton.classList.remove('hidden')
      this.draftOrderButton.classList.add('hidden')
      return
    }

    responseData.forEach(customer => {
      const option = document.createElement('option')
      option.value = customer.id
      option.textContent = customer.name
      option.setAttribute('data-discount', customer.discount)

      if (selectedCustomer === customer.id) {
        option.selected = true
        this.regularSubmitButton.classList.add('hidden')
        this.draftOrderButton.classList.remove('hidden')
      }
      this.customersSelector.appendChild(option)
    })

    this.querySelector('label[for="customer"] span').classList.add('hidden')
  }

  async handleCustomerSelectorChange(e) {
    this.querySelector('label[for="customer"] span').classList.remove('hidden')
    this.regularSubmitButton.classList.add('hidden')
    this.draftOrderButton.classList.add('hidden')
    const target = e.target
    await fetch('/discount/CLEAR')

    if (target.value.length < 1) {
      this.regularSubmitButton.classList.remove('hidden')
      this.draftOrderButton.classList.add('hidden')
      localStorage.removeItem('selectedCustomer')

      // add discount code to cart if exists for sales representative
      if (localStorage.getItem('discount')) {
        await fetch(`/discount/${localStorage.getItem('discount')}`)
      }
    } else {
      this.regularSubmitButton.classList.add('hidden')
      this.draftOrderButton.classList.remove('hidden')
      localStorage.setItem('selectedCustomer', target.value)
      const selectedOption = target.querySelector(':checked')

      if (selectedOption.getAttribute('data-discount')) {
        console.log('selectedOption', selectedOption.getAttribute('data-discount'))
        await fetch(`/discount/${selectedOption.getAttribute('data-discount')}`)
      }
    }
    window.location.reload()
  }
}

customElements.define('draft-order-form', DraftOrderForm)
